import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import appSession from "../../utils/appSession";

const ImpersonationSession = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");
    const expiresAt = searchParams.get("expiresAt");
    const redirectTo = searchParams.get("redirect") || "/whatsappdashboard";
    const impersonatedUser = searchParams.get("impersonatedUser");
    const impersonator = searchParams.get("impersonator");

    if (!token) {
      navigate("/auth", { replace: true });
      return;
    }

    appSession.startImpersonationSession({
      token,
      expiresAt,
      impersonatedUser: impersonatedUser ? JSON.parse(impersonatedUser) : null,
      impersonator: impersonator ? JSON.parse(impersonator) : null,
    });

    navigate(redirectTo, { replace: true });
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-700">
      Creating impersonation session...
    </div>
  );
};

export default ImpersonationSession;
